export default "__VITE_ASSET__4WbviKo5__"